import {Component} from '@angular/core';
import {AbstractQuillToolbarFormatButtonComponent} from '../abstract-quill-toolbar-format-button';

/**
 * Class for the HeadingQuillToolbarButtonComponent
 * @class
 * @extends AbstractQuillToolbarFormatButtonComponent
 *
 * @example
 *
 * ```html
 * <advtech-heading-quill-toolbar-button #customButton></advtech-heading-quill-toolbar-button>
 * ```
 */
@Component({
  selector: 'advtech-heading-quill-toolbar-button',
  templateUrl: './heading-quill-toolbar-button.component.html',
})
export class HeadingQuillToolbarButtonComponent extends AbstractQuillToolbarFormatButtonComponent {
  /**
   * The heading index to tell the template which button to show and which tag to use
   * @type {number}
   */
  headingIndex: number = 0;

  /** @inheritdoc */
  hKeyUp(e): void {
    const keyCode = e.keyCode;
    if (keyCode === 13 || keyCode === 8) {
      this.hSelectionChange();
    }
  }

  /**
   * Gets the native start container from quill
   * @returns {any | Node}
   */
  getNativeStartContainer(): any | Node {
    const nativeRange = (this.quill as any).selection.getNativeRange();
    if (!nativeRange) {
      return false;

    }
    return nativeRange.native.startContainer;

  }

  /** @inheritdoc */
  hSelectionChange(range = null, oldRange = null, source = null): void {
    const nativeStartContainer = this.getNativeStartContainer();
    const tagName = nativeStartContainer ? nativeStartContainer.parentNode.tagName : null;

    switch (tagName) {
      case 'H2':
        this.headingIndex = 2;
        this.classes['ql-active'] = true;
        break;
      case 'H3':
        this.headingIndex = 3;
        this.classes['ql-active'] = true;
        break;
      case 'H4':
        this.headingIndex = 4;
        this.classes['ql-active'] = true;
        break;
      default:
        this.resetButton();
        break;
    }
  }

  /**
   * Resets the heading index and makes the button inactive
   * @returns {void}
   */
  resetButton(): void {
    this.headingIndex = 0;
    this.classes['ql-active'] = false;
  }

  /** @inheritdoc */
  hClick(): void {
    this.headingIndex++;
    if (this.headingIndex > 4) {
      this.headingIndex = 0;
    }
    else if (this.headingIndex === 1) {
      this.headingIndex = 2;
    }
    this.quill.format('header', this.headingIndex, 'user');
    this.classes['ql-active'] = this.headingIndex > 0;
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/heading-quill-toolbar-button/heading-quill-toolbar-button.component.ts